<template lang="jade">
  .wrapper-dayjourney.mb1.center-element(style="width: 100%;" v-if="dj" key="djloaded", v-bind:class="className")
    button.btn.btn-block.btn3d.btn-sm.btn-calendisOpenedar.center-element.dj-button(
    style="z-index: 1"
    @click="editDj",
    @focus="editDj",
    :disabled="!allowEdit || editing || processing",
    v-bind:class="djInfosToShow.class")
      span.fill-container(:class="{'move-text-dj': djInfosToShow.name.length > 12}") {{ djInfosToShow.name }}
    .container-edit-dj(v-if="editing", v-click-outside="close")
      input.form-control(type="text", v-focus="", placeholder="buscar", v-model="search"
      @keyup.enter.prevent.stop="saveFromSearch($event)",
      @keyup.esc="close(true)",
      @blur="inputBlured",
      @keydown="keyEvent($event)")
      button.btn.btn3d.btn-sm.btn-info(@click="activeModal", ref="filterbutton")
        span.glyphicon.glyphicon-glass
    span.glyphicon.glyphicon-alert(v-if="dj.guessFolga", title="Corrigido automaticamente para folga.",
                                   style="color: grey; margin-top: 5px;")

</template>

<script>
import moment from 'moment'
import ClickOutside from 'vue-click-outside'

export default {
  inject: ['openDayJourney'],
  props: {
    dj: {required: true},
    rowNumber: {},
    allowEdit: {type: Boolean}
  },
  data () {
    return {
      editing: false,
      showModal: false,
      previousFocusedElement: null
    }
  },
  computed: {
    matchJourneySearch () {
      return this.$store.getters['matchJourneySearch']
    },
    journeys () {
      return this.$store.state.Sheet.journeys
    },
    search: {
      get () { return this.$store.state.Sheet.journeySearch },
      set (value) {
        this.$store.commit('journeySearch', value)
      }
    },
    lineSelected () {
      return this.$store.state.Sheet.selectedLines.includes(this.rowNumber)
    },
    className () { return `DayJourney-${this.rowNumber}` },
    processing () {
      const process = this.$store.state.Sheet.processing
      return process.djs.includes(this.rowNumber)
    },
    djInfosToShow () {
      let { dj } = this

      if ((this.editing || this.lineSelected) && this.matchJourneySearch) {
        dj = {...dj, journey: this.matchJourneySearch}
      }

      let djInfos = {
        name: '',
        color: dj.journey.color,
        'class': 'btn-' + dj.journey.color + ' ' +
        (this.processing ? 'dj-loading' : '') +
        ((dj.manual_change || dj.forced_journey) && !this.processing ? 'manual-change' : '')
      }

      const isSpecial = dj && dj.journey.start === dj.journey.end && dj.journey.kind !== -1
      const isFerias = dj.journey.kind === -1 && dj.journey.name === 'Férias'
      const isDispensa = dj.journey.name === 'Dispensa' && dj.journey.kind === 0

      if (isSpecial || isFerias) {
        djInfos.name = dj.journey.name
      } else if (isDispensa) {
        djInfos.name = 'D. Parcial'
      } else if (dj.journey.kind === -1) {
        djInfos.name = dj.journey.name
      } else {
        djInfos.name = moment(dj.journey.start).format('HH:mm') + '-' + moment(dj.journey.end).format('HH:mm')
      }
      return djInfos
    }
  },
  methods: {
    editDj () {
      this.editing = true
    },
    async saveFromSearch (e) {
      if (this.matchJourneySearch) {
        this.saveDayJourney(this.matchJourneySearch)
      }
      this.focusPtOrDj('dj')
    },
    close (forceFocusPT = false) {
      this.editing = false
    },
    async saveDayJourney (journey) {
      this.$store.dispatch('changeJourneysLocal', {rowNumber: this.rowNumber, journey, dayJourney: this.dj})
      const pos = this.$store.getters.currentDigit.position
      document.getElementsByClassName(`InputDigit-${pos[0]}-${pos[1]}`)[0].focus()
    },
    async onSelectJourney (journey) {
      this.$modal.hide('journey-picker')
      this.editing = false
      await this.saveDayJourney(journey)
    },
    activeModal () {
      this.$modal.show('journey-picker', {
        callback: this.onSelectJourney,
        onCloseNoSelect: () => {
          const pos = this.$store.getters.currentDigit.position
          document.getElementsByClassName(`InputDigit-${pos[0]}-${pos[1]}`)[0].focus()
        }
      })
    },
    inputBlured () {
      if (!this.editing) { return }
      setTimeout(() => {
        if (document.activeElement !== this.$refs.filterbutton) {
          this.close()
        }
      })
    },
    focusPtOrDj (type = 'pt', inverted = false) {
      inverted = inverted ? -1 : 1
      if (type === 'pt') {
        const pos = this.$store.getters.currentDigit.position
        document.getElementsByClassName(`InputDigit-${pos[0]}-${pos[1]}`)[0].focus()
      } else if (type === 'dj') {
        this.nextDj()
      }
    },
    keyEvent (e) {
      const LEFT = e.key === 'ArrowLeft'
      const UP = e.key === 'ArrowUp'
      const DOWN = e.key === 'ArrowDown'

      if (UP) {
        if (e.shiftKey) {
          this.$store.commit('selectLineByIndex', this.rowNumber)
        }
        this.prevDj()
        e.stopPropagation()
      } else if (DOWN) {
        if (e.shiftKey) {
          this.$store.commit('selectLineByIndex', this.rowNumber)
        }
        this.nextDj()
        e.stopPropagation()
      } else if (LEFT) {
        this.editing = false
        this.$store.commit('setCurrentDigitPosition', [this.rowNumber, 15])
        document.getElementsByClassName(`InputDigit-${this.rowNumber}-15`)[0].focus()
        e.preventDefault()
        e.stopPropagation()
      } else if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'j') {
        e.preventDefault()
        e.stopPropagation()
        this.activeModal()
      }
    },
    nextDj (type = 'search') {
      this.editing = false
      if (this.rowNumber + 1 === this.$store.state.Sheet.currentSheet.rows.length) {
        this.editDj()
        return
      }
      this.openDayJourney(this.rowNumber + 1, type, 'next')
    },
    prevDj (type = 'search') {
      this.editing = false
      if (this.rowNumber - 1 < 0) {
        this.editDj()
        return
      }
      this.openDayJourney(this.rowNumber - 1, type, 'prev')
    },
    canJourneyBeEdited (journey) {
      const BLOCKED_NAMES = ['dispensa', 'suspensão']
      for (let item in BLOCKED_NAMES) {
        if (journey.name.toLowerCase().includes(BLOCKED_NAMES[item])) {
          return false
        }
      }
      return true
    }
  },
  filters: {
    date (date, format) {
      return moment(date).format(format)
    }
  },
  directives: {ClickOutside}
}
</script>

<style scoped>
  .djs-dropdown {
    position: absolute;
    height: 100px;
    width: 400px;
    background-color: white;
    border-radius: 5px;
    -webkit-box-shadow: 0px 6px 5px 2px rgba(0,0,0,0.39);
    -moz-box-shadow: 0px 6px 5px 2px rgba(0,0,0,0.39);
    box-shadow: 0px 6px 5px 2px rgba(0,0,0,0.39);
    overflow: scroll;
  }
  .container-edit-dj {
    display: grid;
    grid-template-columns: 1fr 0.3fr;
    overflow: visible;
  }
  .container-edit-dj > button {
    width: 30px;
    height: 90%;
    margin-top: -2px;
  }

  .wrapper-dayjourney {
    padding-left: 10px;
    padding-right: 10px;
    z-index: 10;
  }
  .djs-drop-search-header {
    display: grid;
    grid-template-columns: 1.8fr repeat(4, 1fr);
  }
  .djs-drop-search-body {
    display: grid;
    grid-template-columns: 1.8fr repeat(4, 1fr);
    height: 20px;
  }
  @keyframes moving-dj-loading {
    0% {
      background-position: 0 0;
    }
    100% {
      background-position: 0px 300px;
    }
  }
  .dj-loading {
    position: absolute;
    width: 100%;
    z-index: -5;
    height: 100%;
    background-image: repeating-linear-gradient(-45deg, transparent, transparent 10px,
    rgba(0, 0, 0, 0.1) 10px,
    rgba(0, 0, 0, 0.1) 20px);
    animation-name: moving-dj-loading;
    animation-duration: 5s;
    animation-iteration-count: infinite;
    -webkit-animation-timing-function:linear;
  }

  .manual-change {
    position: absolute;
    width: 100%;
    z-index: -5;
    height: 100%;
    background-image: repeating-linear-gradient(-45deg,
    transparent,
    transparent 10px,
    rgba(0, 0, 0, 0.1) 10px,
    rgba(0, 0, 0, 0.1) 20px);
  }

  .dj-button span {
    width: 100%;
    overflow: hidden;
  }
  .dj-button {
    overflow: hidden;
    width: 100px;
  }
  @keyframes dj-text-overflow {
    0% { text-indent: 0px }
    100% { text-indent: -50px }
  }
  .move-text-dj:hover {
    animation-timing-function: linear;
    animation: dj-text-overflow 2s infinite;
    animation-direction: alternate;
  }
</style>



// WEBPACK FOOTER //
// DayJourney.vue?5a11c1fe